<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>

<div class="m-2">
    <div class="p-fluid pl-2">
        <h2 class="uppercase">Lista de Precios </h2>
    </div>
</div>
<div class="flex flex-wrap w-full mt-3 p-3 mt-3">
    <p-card class="m-2" subheader="fecha Actualización: {{row.fechaActualizacion | date:'yyyy-MM-dd hh:mm'}}"
        styleClass="w-full p-3 m-2" *ngFor="let row of arrayListaPrecios">
        <p-header>
            <div class="flex">
                <span *ngIf="!row.edit">
                    <h2> {{row.nombreListaPrecios}} <i class="pi pi-pencil cursor-pointer"
                            (click)="row.edit=!row.edit"></i></h2>
                </span>
                <div class="p-2 p-inputgroup" *ngIf="row.edit">
                    <input type="text" pInputText [(ngModel)]="row.nombreListaPrecios">
                    <div class="p-inputgroup-addon"><button pButton icon="pi pi-check-circle"
                            class="p-button p-button-success" (click)="row.edit=false"></button></div>
                </div>
            </div>
        </p-header>
        <div class="p-input flex flex-column">
            <div class="pb-2 w-full">
                <label>Fecha de vígencia</label>
                <p-calendar [(ngModel)]="row.fechaVigencia" [showIcon]="true" [showOnFocus]="false"
                    dateFormat="yy-mm-dd" inputId="buttondisplay" />
                <div class="text-xs">
                    Fecha vigencia: {{row.fechaVigencia | date:'yyyy-MM-dd'}}
                </div>
            </div>
            <div>
                <label>Estado</label>
                <p-inputSwitch [(ngModel)]="row.activo" *ngIf="!row.default"/>
                <div class="text-xs" >
                    Lista {{row.activo?' activa':'inactiva'}}
                </div>
            </div>
            <div>
                <label>Precios para el público en general</label>
                <p-inputSwitch [(ngModel)]="row.default" (click)="setListaDefault(row.idListaPrecios)" />
                <div class="text-xs">
                    {{row.default?'Activo':''}}
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex gap-3 mt-1 ">
                <button pButton icon="pi pi-check-circle" label="Actualizar" styleClass="w-full"
                    class="p-button p-button-success" (click)="updateLista(row)"></button>
            </div>
            <div [innerHTML]="row.msg"></div>
        </ng-template>
    </p-card>
    <p-card class="m-2" subheader="Nueva lista de precios" styleClass=" p-3 m-2">
        <p-header>
            <div class="flex" *ngIf="!new">
                <h2>Nuevo</h2>
            </div>
            <div class="p-2 p-inputgroup" *ngIf="new">
                <input type="text" pInputText [(ngModel)]="nameListOfPrices" placeholder="Nombre lista de precios">
            </div>
        </p-header>
        <div style="min-height:185px">
            <div class="text-center flex justify-content-center" *ngIf="!new">
                <i class="pi pi-plus-circle cursor-pointer" style="font-size: 4.5rem" (click)="new=true;"></i>
            </div>
            <div class="p-input flex flex-column" *ngIf="new">
                <div class="pb-2 w-full">
                    <label>Fecha de vígencia</label>
                    <p-calendar [(ngModel)]="fechaVigencia" [showIcon]="true" [showOnFocus]="false"
                        dateFormat="yy-mm-dd" inputId="buttondisplay" />
                    <div class="text-xs">
                        Fecha vigencia: {{fechaVigencia | date:'yyyy-MM-dd'}}
                    </div>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="flex gap-3 mt-1 align-items-end" *ngIf="new">
                <button pButton icon="pi pi-check-circle" label="Crear" styleClass="w-full" (click)="createLista()"
                    class="p-button p-button-success"></button>

            </div>
            <div [innerHTML]="msg"></div>
        </ng-template>
    </p-card>
</div>
<p-toast key="message"></p-toast>